import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDocumentationStore = defineStore('documentation', () => {
  const folder = ref<string | undefined>(undefined)
  const reloadTrigger = ref<number>(0)

  function setFolder(id: string | undefined) {
    folder.value = id
  }

  function reloadFiles() {
    reloadTrigger.value = reloadTrigger.value + 1
  }

  return {
    setFolder,
    reloadFiles,
    folder,
    reloadTrigger
  }
})
